import React from 'react'
import PropTypes from 'prop-types'
import { ArticleIcon, PeopleIcon } from 'secondstep-components'
import ReportsDropdown from './ReportsDropdown'
import {
  DWB_SUPPORTING_LESSON_INSTRUCTORS_PATH,
  SUPPORTING_LESSON_INSTRUCTORS_PATH,
  USER_MANAGEMENT_PATH,
} from './constants'
import {
  LeaderContainer,
  StyledAccessibleTextLink,
  SupportingInstructorsIconWrap,
} from './component.styles'
import NavigationHelper from 'layers/navigation/navigationHelper'

const K8ReportingLeaderTools = ({
  buttonText,
  classesCount,
  entry,
  error,
  historicalReportingOnClick,
  historicalReports,
  isDownloadingHistoricalReportData,
  isDwbReportRoute,
  isFetchingDocumentUrl,
  isSchoolSummary,
  navigationEvent,
  onClickCurrentYear,
  selectedSite,
}) => {
  const { schoolCsvDownloadTooltip } = entry || {}

  const csvDropdownData = {
    buttonText,
    classesCount,
    error,
    historicalReports,
    historicalReportingOnClick,
    isFetching: isFetchingDocumentUrl || isDownloadingHistoricalReportData,
    onClickCurrentYear,
    schoolCsvDownloadTooltip,
  }
  const supportingInstructorsPath = isDwbReportRoute
    ? DWB_SUPPORTING_LESSON_INSTRUCTORS_PATH
    : SUPPORTING_LESSON_INSTRUCTORS_PATH

  return (
    <LeaderContainer data-testid="LeaderContainer">
      {!isDwbReportRoute && (
        <ReportsDropdown
          {...csvDropdownData}
          isFetchingDocumentUrl={isFetchingDocumentUrl}
        />
      )}
      {isSchoolSummary && (
        <StyledAccessibleTextLink
          ariaLabel="manage-users-link"
          dataTestId="manage-users-link"
          onClick={() =>
            navigationEvent(
              `${USER_MANAGEMENT_PATH}/${selectedSite}`,
              NavigationHelper.types.OPEN,
            )
          }
        >
          <PeopleIcon /> Manage Users
        </StyledAccessibleTextLink>
      )}
      <StyledAccessibleTextLink
        ariaLabel="supporting-instructors-link"
        dataTestId="supporting-instructors-link"
        href={supportingInstructorsPath}
      >
        <SupportingInstructorsIconWrap>
          <ArticleIcon />
        </SupportingInstructorsIconWrap>{' '}
        Supporting Instructors
      </StyledAccessibleTextLink>
    </LeaderContainer>
  )
}

K8ReportingLeaderTools.propTypes = {
  buttonText: PropTypes.string,
  classesCount: PropTypes.number,
  entry: PropTypes.object,
  error: PropTypes.object,
  historicalReportingOnClick: PropTypes.func,
  historicalReports: PropTypes.array,
  isDownloadingHistoricalReportData: PropTypes.bool,
  isDwbReportRoute: PropTypes.bool,
  isFetchingDocumentUrl: PropTypes.bool,
  isSchoolSummary: PropTypes.bool,
  navigationEvent: PropTypes.func,
  onClickCurrentYear: PropTypes.func,
  selectedSite: PropTypes.number,
}

export default K8ReportingLeaderTools
